import { notification } from 'antd';
import styled from 'styled-components';

export default styled(notification)`
	// Add your styles here
`;
